module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2d864963fd2e97abc24f77a62b965b73.png";